package com.example.hukakmp.data

import dev.gitlive.firebase.storage.Data
import org.khronos.webgl.Uint8Array

actual fun storageData(bytes: ByteArray): Data {
    val data = Uint8Array(bytes.size)
    data.set(bytes.toTypedArray())
    return Data(data)
}
